import preferenceGroups from "./preferenceGroups";
import isPreferenceGroupVisible from "./isPreferenceGroupVisible";

export default function filterUserPreferencesForSave(values, menuVisibility) {
  const allowedKeys = new Set();

  // 1. Add keys from groups that are visible/authorized for this user
  Object.entries(preferenceGroups).forEach(([groupName, group]) => {
    if (isPreferenceGroupVisible(groupName, menuVisibility)) {
      group.preferenceKeys.forEach(key => allowedKeys.add(key));
    }
  });

  // 2. Determine which keys *are* restricted (i.e., tied to permission groups)
  const restrictedKeys = new Set(
    Object.values(preferenceGroups).flatMap(g => g.preferenceKeys)
  );

  // 3. Any key not in a restricted group is always allowed
  Object.keys(values).forEach(key => {
    if (!restrictedKeys.has(key)) {
      allowedKeys.add(key);
    }
  });

  // 4. Return filtered + normalized preferences:
  //    - Only include allowed keys
  //    - Convert undefined → null for API compatibility
  return Object.fromEntries(
    Object.entries(values)
      .filter(([key]) => allowedKeys.has(key))
      .map(([key, val]) => [key, val === undefined ? null : val])
  );
}
